module.exports = __webpack_public_path__ + "img/tea.97c8fdca.png";